export default __webpack_public_path__ + "static/media/myAvatar.1103e4c1.svg";